// extracted by mini-css-extract-plugin
export default {"app":"Routes_app__RhOgm","appLogo":"Routes_appLogo__Q9yjd","appLogoSpin":"Routes_appLogoSpin__8EavZ","appHeader":"Routes_appHeader__NSZmj","appLink":"Routes_appLink__bD+LO"};